import { render } from "./AgentDashboard.vue?vue&type=template&id=4e29d048&scoped=true"
import script from "./AgentDashboard.vue?vue&type=script&lang=js"
export * from "./AgentDashboard.vue?vue&type=script&lang=js"

import "./AgentDashboard.vue?vue&type=style&index=0&id=4e29d048&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\E-TICKET\\eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e29d048"]])

export default __exports__